let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("150WG")).then(() => parcelRequire('4U2eK'));